import { render, staticRenderFns } from "./ToutBox.vue?vue&type=template&id=6a46d8e3"
import script from "./ToutBox.vue?vue&type=script&lang=js"
export * from "./ToutBox.vue?vue&type=script&lang=js"
import style0 from "./ToutBox.vue?vue&type=style&index=0&id=6a46d8e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports